import { REACT_APP_API } from '../../config'
import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'

const DELIVERY_COST_ENDPOINT = REACT_APP_API + '/costs/delivery'

export async function getCostosDePatentamiento(patentamientoData) {
  const costoDePatentamiento = await axios.get(`${DELIVERY_COST_ENDPOINT}`,{ params: patentamientoData })
  .then((res) => res.data.data)

  return costoDePatentamiento ? deepFreeze(costoDePatentamiento) : 0;
}
